<template>
  <section class="cases">
    <div class="section-wrap">
      <Header :trigger="trigger"/>
    </div>
    <div class="container">
      <h1 class="promo__head">i have worked with design for over 5 years, ranging from the smallest prototypes for user tests to big cooperate websites.</h1>
      <p class="promo__text">here is a few things I’ve worked with in corporation with HGW</p>
      <section class="cases__cases about__split">
        <div>
            <h2>design systems</h2>
            <p class="cases__list__case__text">I have been a part of the creation and development of multiple big design systems. A couple of them is for danske bank, yousee, erhvervsstyrrelsen. Design systems are here to create a better product and a bigger cohesive experience for the user.</p>
        </div>
        <div>
          <h2>pharma industry</h2>
          <p class="cases__list__case__text">In the pharma industry I’ve worked with a variety of products. One of them is Novo Nordisk, where I’ve been digitalized paper products into digital solutions. Another one is Leo Pharma, where I was a part of their ctrl project, to make a more transparent way to sell their psoriasis products. The ctrl project was all around, from a physical product design to digital website solutions.</p>
        </div>
        <div>
          <h2>design & coding</h2>
          <p class="cases__list__case__text">As a full time designer I also code. The understanding of coding is getting more and more important, because the terms “designer and front-end” is getting closer and closer to each other. For me, it is very important to be able to create the things I design.</p>
        </div>
        <div>
          <h2>the way i execute</h2>
          <p class="cases__list__case__text">most of the project needs to be delivered or prototyped somehow. All deliveries will be executed in Zeplin for the developers, prototyped in Principle or InVision to showcase motion or flows. A sketch document will be shared with other designers if needed.</p>
        </div>
      </section>
    </div>
  </section>
</template>

<script>
import './style.scss';
import Header from '@/components/Header/Header';

export default {
  name: 'MikkelCases',
  data() {
    return {
    };
  },
  methods: {
  },
  components: {
    Header,
  },
  props: {
    trigger: Function,
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Cases/Mikkel.vue